import { Outlet } from "react-router-dom";

export const RequireData = () => {
  return <Outlet />;
};
